<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		getAppInfo
	} from './common/utils/check.js'
	export default {
		data() {
			return {
				name: 'app',
			}
		},
		watch: {
			$route: function(to) {
				//如果是移动端打开就跳到移动写作端
				if (!this.$pc) {
					const url = 'https://writing.gw-reader.com'
					window.open(url, '_self')
				}
			}
		},
		created() {
			console.log("Appstart");
			getAppInfo()

			this.$eventRequest({
				mode: 'APPSTART',
				title: 'APPSTART',
				etype: 'click'
			})
		}
	}
</script>

<style>
	@import './assets/global.css';

	/*引入公共样式*/
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: left; */
		color: #656565;
		line-height: 22px;
		width: 100%;
		min-width: 1100px;
		height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: #F1F1F1;
	}

	.container {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.containerPage {
		background-color: #ffffff;
		border-radius: 6px;
		min-height: 60%;
		margin-bottom: 30px;
		overflow: hidden;
	}

	.pdlr-20 {
		padding-left: 20px;
		padding-right: 20px;
	}

	.pageTitle {
		padding: 20px 0;
		font-size: 18px;
		font-weight: bold;
	}

	a {
		color: #656565;
		text-decoration: none;
	}
</style>